const BASE = window.MANIFEST_DATA.data[0].BaseUrl;
const CustomerId = window.MANIFEST_DATA.data[0].CustomerId;


export const API_WEB_URLS = {
 // BASE: "http://apitruecartoons.shinewellsofttech.co.in/api/V1/",
//  BASE: "http://apicgshreenath.shinewellsofttech.co.in/api/V1/",
 // BASE: "http://apianna.shinewellsofttech.co.in/api/V1/",
  // BASE: "http://apiusha.shinewellsofttech.co.in/api/V1/",
  // BASE: "http://apiankit.shinewellsofttech.co.in/api/V1/",
  // BASE: "http://apishanti.shinewellsofttech.co.in/api/V1/",


  // BASE: "http://apicgdemo.shinewellsofttech.co.in/api/V1/",

  // BASE: "http://apicgkrishna.shinewellsofttech.co.in/api/V1/",

  //  BASE: "https://localhost:44379/api/V1/",
  BASE : BASE,
  LOGIN: "Authentication/Login",
  //
  MASTER: "Masters",
  MASTER_COUNTRY: "CountryMaster",

//1 TrueCartoons Cg_Demo
//2 Shreenath
//3 Anna
//4 Usha
//5 Ankit
//6 Shanti
//7 DemoNew
//8 Krishna
//9 Sakshi
//10 Shree
//11 Bhagirath
//12 Bhagirath OG
//13 Lakshay / Mahaveer / Creative
//14 Mahaveer OG


  Customer : CustomerId,
  // Customer : 7,
  
  //

  INVOICEL : "InvoiceL",
  INVOICEH : "InvoiceH",
  INVOICETAX : "InvoiceTax",
  INVOICECHARGE : "InvoiceCharge",
  INVOICETAXABLE : "InvoiceTaxableAmount",

  AddMoneyReceipt: "AddMoneyReceipt",
  PlyAdjustmentMaster: "PlyAdjustmentMaster",
  UserRights: "UserRights",
  ITEMTYPEMASTER: "ItemTypeMaster",
  Ply:"Ply",
  AddEdit:"AddEdit_Master",
  Voucher:"Voucher",
  Unit:"UnitMaster",
  State:"State",
  SheetSizingH:"SheetSizingH",
  SheetSizingL:"SheetSizingL",
  GetJobcard_Sheetsizing : "GetJobcard_Sheetsizing ",
  SheetSizingH:"SheetSizingH",
  CalculationType:"CalculationType",
  PaperType:"PaperType",
  ConAdd:"ConAdd",
  HeightCal:"HeightCal",
  LengthCal:"LengthCal",
  Tax:"Tax",
  Ledger:"Ledger",
  GSTGroupType:"GSTGroupType",
  User:"User",
  GLOBALOPTIONS : 'UpdateGlobalOptions',
  CHANGEPASSWORD : 'ChangePassword',
  ItemTypeMaster : 'ItemTypeMaster'


  // PRODUCT_CATEGORY: "Masters/ProductCategory",
  // PRODUCT_BRAND: "Masters/ProductBrand",
  // PRODUCT_ATTRIBUTE: "Masters/ProductAttribute"
};
